import { useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Lock, ArrowLeft, Eye, EyeSlash } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const uid = params.get("uid") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token || !uid) toast.error("Enlace invalido");
  }, [token, uid]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error("Minimo 6 caracteres"); return; }
    if (pw !== pw2) { toast.error("Las contrasenas no coinciden"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, uid, new_password: pw });
      toast.success("Contrasena actualizada");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al actualizar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center p-6" data-testid="reset-password-page">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase font-semibold text-gray-500 hover:text-[#CCFF00] mb-6 transition-colors">
          <ArrowLeft size={14} /> Volver al login
        </Link>
        <div className="bg-[#141414] border border-white/10 p-8 relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-[#CCFF00]" />
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#CCFF00] mb-1 flex items-center gap-2"><Lock size={12} /> Seguridad</p>
          <h1 className="font-['Barlow_Condensed'] text-4xl font-black uppercase tracking-tighter mb-6">Nueva Contrasena</h1>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-[10px] uppercase tracking-widest text-gray-400">Nueva contrasena</Label>
              <div className="relative mt-1">
                <Input type={show ? "text" : "password"} required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Minimo 6 caracteres" className="bg-[#0A0A0A] border-white/20 text-white h-11 pr-10" data-testid="new-password-input" />
                <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-white">
                  {show ? <EyeSlash size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>
            <div>
              <Label className="text-[10px] uppercase tracking-widest text-gray-400">Confirmar contrasena</Label>
              <Input type={show ? "text" : "password"} required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Repite tu contrasena" className="bg-[#0A0A0A] border-white/20 text-white h-11 mt-1" data-testid="confirm-password-input" />
            </div>
            <Button type="submit" disabled={loading || !token || !uid} className="w-full bg-[#CCFF00] text-black hover:bg-[#B3E600] font-bold uppercase tracking-wide" data-testid="reset-submit">
              {loading ? "Guardando..." : "Actualizar contrasena"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
